document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".reveal-section").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.4, y: 10 },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "back.out(1.5)",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section").forEach((section) => {
    gsap.fromTo(
      section.querySelectorAll("h2, p, span, h4, h3"),
      { opacity: 0.4, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 1.3,
        ease: "back.out(1.5)",
        stagger: 0.2,
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section-rotate").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.4, y: 20, rotate: -10 },
      {
        opacity: 1,
        y: 0,
        rotate: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section-rotate-cw").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.4, y: 20, rotate: -10 },
      {
        opacity: 1,
        y: 0,
        rotate: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section-rotate-ccw").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.4, y: 20, rotate: 10 },
      {
        opacity: 1,
        y: 0,
        rotate: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section-slide-left").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.7, x: -50 },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".reveal-section-slide-right").forEach((section) => {
    gsap.fromTo(
      section,
      { opacity: 0.4, x: 50 },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.utils.toArray(".fade-up").forEach((el) => {
    gsap.fromTo(
      el,
      { opacity: 0.4, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 75%",
          end: "bottom 25%",
          toggleActions: "restart none none none",
        },
      }
    );
  });

  gsap.to(".skewed", {
    skewX: 10,
    duration: 1,
    ease: "power1.inOut",
    scrollTrigger: {
      trigger: ".skewed",
      start: "bottom top",
      end: "top bottom",
      scrub: true,
    },
  });

  gsap.to(".parallax-layer", {
    y: "-10%",
    ease: "none",
    scrollTrigger: {
      trigger: ".parallax-layer",
      start: "top bottom",
      end: "bottom top",
      scrub: true,
    },
  });

  // gsap.to(".met-advance-meter-img", {
  //   y: "-20%",
  //   scale: 1.2,
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".met-advance-meter-main",
  //     start: "top bottom",
  //     end: "bottom top",
  //     scrub: true,
  //   },
  // });

  // gsap.to("#needle", {
  //   rotate: "45deg",
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".weight-scale",
  //     start: "top center",
  //     end: "bottom center",
  //     scrub: true,
  //   },
  // });
  gsap.utils.toArray(".split-text").forEach((el) => {
    const words = el.textContent.split(" ");
    el.innerHTML = words.map((word) => `<span>${word}</span>`).join(" ");
    gsap.fromTo(
      el.querySelectorAll("span"),
      { opacity: 0.4, y: 20 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.05,
        duration: 1,
        ease: "back.out(1.2)",
        scrollTrigger: {
          trigger: el,
          start: "top 70%",
          toggleActions: "restart none none none",
        },
      }
    );
  });
});
